import { useLayoutEffect, useMemo, useState } from 'react';
import { useStateSelector } from '../../../stateManager';
import { createFilterValueByNameSelector } from '../../../utils/selectors';
import { useValueRef } from '../../../../../../../../hooks/useValueRef';
import { useFilterHandler } from '../../../services/filter';
import { useEvent } from '../../../../../../../../hooks/useEvent';

export const useFilterState = (name, options) => {
  const { visibleChangeCb } = options ?? {};

  const selectFilterValue = useMemo(
    () => createFilterValueByNameSelector(name),
    [name]
  );
  const filterValue = useStateSelector(selectFilterValue);

  const [visible, setVisible] = useState(false);
  const [value, setValue] = useState(filterValue);

  const valueRef = useValueRef(value);

  useLayoutEffect(() => {
    if (valueRef.current !== filterValue) {
      setValue(filterValue);
    }
  }, [filterValue, valueRef]);

  const onChange = useFilterHandler();

  const onVisibleChange = (visible) => {
    setVisible(visible);

    if (!visible && value !== filterValue) {
      setValue(filterValue);
    }

    if (typeof visibleChangeCb === 'function') {
      visibleChangeCb(visible);
    }
  };

  const onOk = useEvent(() => {
    onChange(name, value);
    setVisible(false);
  });

  const onReset = useEvent(() => {
    onChange(name, undefined);
    setValue(undefined);
    setVisible(false);
  });

  return {
    value,
    setValue,
    visible,
    onVisibleChange,
    onOk,
    onReset,
    hasFilterValue: Boolean(filterValue),
  };
};
